import React from 'react';
import './Navbar.css';
import logo from '../../data/img/logo.png';
import login from '../../data/img/aRW.png';
import logo2 from '../../data/img/Group 10009.png';
import registration from '../../data/img/aRB.png';

const Navbar = () => {
    return (
        <>
        <div className="container">
            <nav className="navbar">
                <div className="logo-aria">
                    <img src={logo} alt=""/>
                </div>
                <div className="login-aria">
                    <button className='login-btn'>
                    <span>Login</span> 
                    <img src={login} alt=""/>
                    </button>
                    <button className='registration-btn'>
                    <span>Registration</span> 
                        <img src={registration} alt=""/>
                    </button>

                    <img src={logo2} alt=""/>
                </div>
            </nav>
        </div>
        </>
    );
};

export default Navbar;